import React from 'react';
import { Field } from 'formik';
import PreferencesTitleSection from '../icons/PreferencesTitleSection';
import OptSwitch from '../OptSwitch';
import FieldNote from '../../containers/preferences/PreferencesFieldNoteContainer';
import withTranslate from '../withTranslate';
import ErrorMessageList from '../notifications/ErrorMessageList';

export interface VoiceFieldProps {
  values: {
    pending_voice: string | null;
    voiceOptIn: boolean;
  };
  setValues: (o: object) => void;
  _t: (str: string, replacements?: {}) => string[];
  errors: {
    voice?: string[];
  };
  touched: {
    voice: boolean;
  };
}

export const VoiceField = ({
  values,
  setValues,
  _t,
  errors,
  touched,
}: VoiceFieldProps) => {
  return (
    <fieldset className="preference-section voice-section">
      <legend className="screen-reader">{_t('Opt-In Voice')}</legend>
      <div className="preference-section-header">
        <PreferencesTitleSection type={'voice'} title={_t('Opt-In Voice')} />
        <OptSwitch
          screenReaderPhrase={_t('Opt-In Voice')}
          optedIn={values.voiceOptIn}
          onClick={() => {
            setValues({
              ...values,
              voiceOptIn: !values.voiceOptIn,
            });
          }}
        />
      </div>

      <div className="input-section">
        <label htmlFor={'voice'} className="preference-label">
          {_t('Phone Number (US Number Only)')}
        </label>
        <div>
          <Field
            className="preference-input"
            id={'voice'}
            name={'voice'}
            placeholder={_t('Example: (303) 333-3333')}
            autoComplete="tel"
            onChange={(e: any) => {
              setValues({
                ...values,
                voice: e.target.value,
                voiceOptIn: true,
              });
            }}
            aria-describedby={'voice-error-list'}
          />
          <button
            className="clear-field"
            type="button"
            aria-label={_t('Clear voice message field contents').join('')}
            onClick={() =>
              setValues({ ...values, voice: '', voiceOptIn: false })
            }
          >
            <span aria-hidden="true">&times;</span>
          </button>
        </div>
      </div>
      <div aria-live="polite" aria-atomic="true">
        <div id={'voice-error-list'}>
          {touched.voice && (
            <ErrorMessageList errors={errors.voice} field={'voice'} limit={3} />
          )}
        </div>
        {values.voiceOptIn && values.pending_voice && (
          <div className={'field-message'}>
            {_t(
              'Please call {{from_voice}} to confirm your intent to receive ballot status updates via voice call. Updates will begin once your phone number is confirmed.',
              { from_voice: '(720) 225-0492' },
            )}
          </div>
        )}
        {values.voiceOptIn && !values.pending_voice && (
          <div className={'field-message'}>
            {_t('You will receive ballot updates via Voice Call')}
          </div>
        )}
        {!(errors.voice && touched.voice) && (
          <FieldNote
            field={'voice'}
            optStatus={values.voiceOptIn}
            replacements={{}}
          />
        )}
      </div>
    </fieldset>
  );
};

export default withTranslate(VoiceField);
